import { useApi, Res } from '../../state/api';
import { useTranslation } from '../../i18n/i18n';
import { ProductListing } from '../ProductListing/ProductListing';
import { Loader } from '../Loader/Loader';

export const ViewedProducts = (): JSX.Element => {
	const { data } = useApi(Res.viewedProducts, {});
	const t = useTranslation().product;

	if (!data) return <Loader />;
	if (data.length === 0) return <></>;

	return (
		<>
			<h2>{t.viewedProducts}</h2>
			<ProductListing products={data} />
		</>
	);
};
